export const base_roles = {
  TST_Access: [
    "CTP.BEC.TSTReadOnly.US",
    "CTP.Internal.TSTReadOnly.US",
    "CTP.TSTAdmin",
    "CTP.CallCenter.TSTReadOnly.MX",
    "CTP.CallCenter.TSTReadOnly.PR",
    "CTP.CallCenter.TSTReadOnly.HI",
    "CTP.CallCenter.TSTReadOnly.CA",
  ],
  VCM:[
    "CTP.VCMAdmin",
   ],
  VCM_AdminPlus:[
    "CTP.VCMAdminPlus"
  ],
  TSTAdmin:[
    "CTP.TSTAdmin"
  ],
  RemoteAuth:[
    "CTP.TSTRemoteAuth"
  ]
};

